"use strict";
/*jshint esversion: 11 */

import React, {Fragment, useState} from 'react';
import PropTypes from "prop-types";
import { handleNotificationUpload } from './CsfNotificationItemUploadHandler';

export default function CsfMembreNotificationsItem({
                                                     notificationId,
                                                     attendanceId,
                                                     html_id,
                                                     created_date,
                                                     title,
                                                     type,
                                                     priority,
                                                     is_read,
                                                     activityName,
                                                     recognitionCode,
                                                     formation_date,
                                                     notificationIsRead,
                                                     apiUrl,
                                                     apiEnv,
                                                     accessToken
                                                   }) {

  const NOTIFICATION_TYPE = {
    DEMANDE_DE_DISPENSE: 0,
    VERIFICATION_DE_PRESENCE_DEMANDE: 1,
    DEMANDE_DE_PAIEMENT: 2,
    DEMANDE_INFOLETTRE: 3,
    DISPENSE: 4,
    PRESENCE: 5
  };

  const NOTIFICATION_PRIORITY = {
    AUCUNE_ACTION_A_PRENDRE: 0,
    ACTION_ATTENDUE: 1,
    ACTION_IMMINENTE: 2
  };

  const [isRead, setIsRead] = useState(is_read);

  // Ajouts pour upload
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isError, setIsError] = useState(false);

  function formatDate(dateString) {
    const language = document.querySelector('html').getAttribute('lang');
    const formattedDate = new Date(dateString).toLocaleDateString(language);

    return formattedDate;
  }

  function onNotificationOpen(notificationId) {
    if (isRead === false) {
      setIsRead(true);
      notificationIsRead(notificationId);
    }
  }

  function getNotificationIcon(priority) {
    if (priority === NOTIFICATION_PRIORITY.ACTION_IMMINENTE) {
      // icone de i rouge
      return (
        <span className="accordion-btn-icon flex-shrink-0">
          <i className="icon icon-red icon-member-exclamation"><span className="d-none">&nbsp;</span></i>
        </span>
      );
    } else if (priority === NOTIFICATION_PRIORITY.ACTION_ATTENDUE) {
      // icone de i bleu
      return (
        <span className="accordion-btn-icon flex-shrink-0">
          <i className="icon icon-member-exclamation"><span className="d-none">&nbsp;</span></i>
        </span>
      );
    } else if (priority === NOTIFICATION_PRIORITY.AUCUNE_ACTION_A_PRENDRE) {
      // Pas d'icone
      return (
        <span className="accordion-btn-icon --empty flex-shrink-0">&nbsp;</span>
      );
    }
  }

  function getNotificationTypeName(type) {
    if (type === NOTIFICATION_TYPE.DEMANDE_DE_DISPENSE) {
      return (<Fragment>{window.Drupal.t('membre.notification.type.demande_de_dispense')}</Fragment>);
    } else if (type === NOTIFICATION_TYPE.VERIFICATION_DE_PRESENCE_DEMANDE) {
      return (<Fragment>{window.Drupal.t('membre.notification.type.presence')}</Fragment>);
    } else if (type === NOTIFICATION_TYPE.DEMANDE_DE_PAIEMENT) {
      return (<Fragment>{window.Drupal.t('membre.notification.type.payment')}</Fragment>);
    } else if (type === NOTIFICATION_TYPE.DEMANDE_INFOLETTRE) {
      return (<Fragment>{window.Drupal.t('membre.notification.type.infolettre')}</Fragment>);
    } else if (type === NOTIFICATION_TYPE.DISPENSE) {
      return (<Fragment>{window.Drupal.t('membre.notification.type.dispense')}</Fragment>);
    } else {
      return (<Fragment></Fragment>);
    }
  }

  function isUploadActionDisplayed(priority) {
    return (priority === NOTIFICATION_PRIORITY.ACTION_IMMINENTE || priority === NOTIFICATION_PRIORITY.ACTION_ATTENDUE);
  }

  // Handler de sélection de fichier
  const handleFileChange = (e) => {
    setIsError(false);
    if (e.target.files && e.target.files.length > 0) {
      setSelectedFile(e.target.files[0]);
    } else {
      setSelectedFile(null);
    }
  };

  // Handler de sélection de fichier
  const handleFileRemoval = () => {
    setIsError(false);
    setSelectedFile(null);

    // TODO : ne pas vider le value du input via document change
    const input = document.getElementById(`NotificationFile_${html_id}`);
    if (input) {
      input.value = '';
      input.dispatchEvent(new Event('change'));
      input.focus();
    }
  };

  // Handler du clic sur "Soumettre" pour upload du fichier
  const handleUpload = () => {
    handleNotificationUpload({
      selectedFile,
      setIsUploading,
      setIsError,
      attendanceId,
      apiUrl,
      apiEnv,
      accessToken,
      notificationId
    });
  };

  return (
    <div className="notifications__item">
      <button
        className="notifications__accordion-btn d-flex align-items-center"
        data-toggle="collapse"
        data-target={"#notification-" + html_id} aria-expanded="false"
        aria-controls={"#notification-" + html_id}
        aria-label={window.Drupal.t('membre.summary.detail.aria-label')}
        onClick={() =>{onNotificationOpen(notificationId)} }>

        {getNotificationIcon(priority)}
        <span className="flex-shrink-0">{formatDate(created_date)}</span>
        <span className="accordion-btn-text flex-grow-1">
          {priority === NOTIFICATION_PRIORITY.ACTION_IMMINENTE && (
            <span><b>{window.Drupal.t('membre.notification.reminder')}</b> - </span>
          )}
          {getNotificationTypeName(type)}
        </span>
        <span className="flex-shrink-0">{isRead ? window.Drupal.t('membre.notification.read') : window.Drupal.t('membre.notification.unread')}</span>
        <img className="img-arrow flex-shrink-0" src="/themes/custom/tink/dist/assets/chevron-left.svg" alt="chevron"/>
      </button>

      <div id={"notification-" + html_id} className="collapse notifications__accordion-details">
        {isUploadActionDisplayed(priority) ? (
          <div>
            <span className="details-title">{title}</span>
            <span className="details-num">{window.Drupal.t('fournisseur.activities-list.table.number')} {recognitionCode}</span>
            <span className="details-activity-name">{activityName}</span>
            <span className="details-date">{window.Drupal.t('membre.notification.accordion.date-label')} {formatDate(formation_date)}</span>
            <div className="form-group file-row">
              <div className="file-custom">
                <small className="fake-label">{window.Drupal.t('membre.file-input.label')}</small>
                <input type="hidden" className="file-name" name=""/>
                <input
                  onChange={handleFileChange}
                  type="file"
                  className="visually-hidden"
                  id={`NotificationFile_${html_id}`}
                  name={`NotificationFile_${html_id}`}
                  accept=".doc,.docx,.pdf,.png,.jpg,.jpeg"
                />
                <label className="no-style-label" htmlFor={`NotificationFile_${html_id}`}>
                  {window.Drupal.t('fournisseur.gestion.file.btn')}<span
                    className="sr-only"> {window.Drupal.t('fournisseur.gestion.cv.label')}</span>
                </label>
                {selectedFile &&
                  <div className="selectedFile">
                    <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')}: </span>
                    <span className="name">{selectedFile.name}</span>
                    <button className="removeFile" data-toggle="tooltip" title={window.Drupal.t('fournisseur.gestion.file.deselected')} onClick={handleFileRemoval}>
                      <span className="name"></span><i className="icon icon-remove"></i>
                    </button>
                  </div>
                }
              </div>
            </div>
            {isError && (
              <div className="alert alert-danger mt-2" role="alert">
                {window.Drupal.t('Une erreur est survenue lors de l\'envoi du fichier.')}
              </div>
            )}
            {selectedFile &&
              <button
                className="button btn-pale btn-larger mt-1 notification-save-file"
                onClick={handleUpload}
                disabled={isUploading}
                type="button"
              >
                {isUploading ? window.Drupal.t('membre.file-input.uploading') : window.Drupal.t('fournisseur.gestion.submit.label')}
              </button>
            }
          </div>
        ) : (
          <span className="details-title">{title}</span>
        )}
      </div>
    </div>
  );

}

CsfMembreNotificationsItem.propTypes = {
  notificationId: PropTypes.string.isRequired,
  attendanceId: PropTypes.string.isRequired,
  html_id: PropTypes.string.isRequired,
  created_date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired,
  priority: PropTypes.number.isRequired,
  is_read: PropTypes.bool.isRequired,
  activityName: PropTypes.string.isRequired,
  recognitionCode: PropTypes.string,
  formation_date: PropTypes.string,
  notificationIsRead: PropTypes.func.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  accessToken: PropTypes.string.isRequired,
};
